module.exports = __webpack_public_path__ + "img/热点榜单ico.4d4ccd3a.png";